module.exports = __webpack_public_path__ + "static/media/gallery.a3a68789.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/gallery.svg
// module id = 464
// module chunks = 0